import React, { createContext, useContext, useState, useCallback } from 'react';

const SplitPanelContext = createContext();

export const SplitPanelProvider = ({ children }) => {
  const [splitPanelContent, setSplitPanelContent] = useState(null);
  const [splitPanelTitle, setSplitPanelTitle] = useState('');
  const [splitPanelHeader, setSplitPanelHeader] = useState(null);
  const [splitPanelOpen, setSplitPanelOpen] = useState(false);

  // Preferencias del SplitPanel: posición lateral (derecha) por defecto
  const [splitPanelPreferences, setSplitPanelPreferences] = useState({
    position: 'side', // 'side' para panel lateral derecho, 'bottom' para panel inferior
  });

  const closeSplitPanel = useCallback(() => {
    setSplitPanelOpen(false);
    setSplitPanelContent(null);
    setSplitPanelTitle('');
    setSplitPanelHeader(null);
  }, []);

  const openSplitPanel = useCallback((content, title = '', header = null) => {
    setSplitPanelContent(content);
    setSplitPanelTitle(typeof title === 'string' ? title : '');
    setSplitPanelHeader(header);
    setSplitPanelOpen(true);
  }, []);

  const setSplitPanelHeaderContent = useCallback((header) => {
    setSplitPanelHeader(header);
  }, []);

  const handleSplitPanelToggle = useCallback(({ detail }) => {
    // detail.open indica el estado deseado del panel después del toggle
    setSplitPanelOpen(detail.open);

    // Si se cierra, también limpiamos el contenido
    if (detail.open === false) {
      setSplitPanelContent(null);
      setSplitPanelTitle('');
      setSplitPanelHeader(null);
    }
  }, []);

  const handleSplitPanelPreferencesChange = useCallback(({ detail }) => {
    // Actualizar las preferencias cuando el usuario las cambia en el modal
    setSplitPanelPreferences(detail);
  }, []);

  const value = {
    splitPanelContent,
    splitPanelTitle,
    splitPanelHeader,
    splitPanelOpen,
    splitPanelPreferences,
    openSplitPanel,
    closeSplitPanel,
    setSplitPanelHeaderContent,
    handleSplitPanelToggle,
    handleSplitPanelPreferencesChange
  };

  return (
    <SplitPanelContext.Provider value={value}>
      {children}
    </SplitPanelContext.Provider>
  );
};

export const useSplitPanel = () => {
  const context = useContext(SplitPanelContext);
  if (!context) {
    throw new Error('useSplitPanel must be used within a SplitPanelProvider');
  }
  return context;
};
